import { ApplicationError } from "./ApplicationError"

/*
 * 主に認証必須画面で利用するエラークラス。
 * 認証必須画面では必ず corporationId がclAuthに格納されているはずなので、それが格納されていなければ本エラークラスをThrowする。
 */
export class NotFoundCorporationIdOnClAuthError extends ApplicationError {
  constructor() {
    super({
      className: "NotFoundCorporationIdOnClAuthError",
      message: "corporationIdの値がclAuthに設定されていません。",
    })
  }
}
